export default __webpack_public_path__ + "static/media/thumb.c37a9084.png";